import { ReactNode, JSX } from "react";
import { userHasRoles, userHasUnixRoles } from "../../misc/utils";

export const HasRole = ({ roles, children, optionalUnixRoles }: { roles: string[], children: ReactNode, optionalUnixRoles?: string[] }): JSX.Element | null => {
    let shouldAllow = userHasRoles(roles)
    if (optionalUnixRoles?.length) {
        shouldAllow = shouldAllow || userHasUnixRoles(optionalUnixRoles)
    }
    if (!shouldAllow) {
        return null
    }
    return <>{children}</>
}